/*!
 * Connecto Smart Search v3 — 2026-10-24
 * Recherche intelligente du header : intentions (budget, stock, marque, catégorie),
 * correction orthographique + synonymes FR/AR, classement, ajout rapide au panier,
 * recherche vocale, historique, tendances, raccourcis clavier.
 * Données : /search/suggest.json (Shopify Predictive Search) + /search?view=ctindex.
 */
(function () {
  'use strict';

  var INDEX_URL = '/search?view=ctindex';
  var INDEX_KEY = 'cs3_index_v1';
  var INDEX_TTL = 12 * 3600 * 1000;
  var HIST_KEY = 'cs3_hist';
  var FIELDS = 'title,product_type,variants.title,vendor,variants.sku,variants.barcode,tag';
  var NF = new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 0 });

  /* ---------- Utilitaires ---------- */
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#039;'); }
  function norm(s) {
    return String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase()
      .replace(/[’'`]/g, ' ').replace(/[^\p{L}\p{N}+.\s"]/gu, ' ').replace(/\s+/g, ' ').trim();
  }
  function money(v) { var n = parseFloat(v); return isNaN(n) ? '' : NF.format(n) + ' MAD'; }
  function shortTitle(t) { return String(t).split(/\s[—–|]\s|\s-\s/)[0].trim(); }
  function lev(a, b) {
    if (a === b) return 0; if (!a.length) return b.length; if (!b.length) return a.length;
    var prev = [], cur = [], i, j;
    for (j = 0; j <= b.length; j++) prev[j] = j;
    for (i = 1; i <= a.length; i++) {
      cur = [i];
      for (j = 1; j <= b.length; j++) cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
      prev = cur;
    }
    return prev[b.length];
  }
  function track(name, params) {
    try { if (typeof window.gtag === 'function') window.gtag('event', name, params); } catch (e) {}
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: 'cs3_' + name }, params)); } catch (e) {}
  }
  function lsGet(k, d) { try { var v = localStorage.getItem(k); return v ? JSON.parse(v) : d; } catch (e) { return d; } }
  function lsSet(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }

  /* ---------- Synonymes FR / darija / arabe (s'ajoutent au dictionnaire du thème) ---------- */
  var EXTRA_SYN = [
    'فأرة,ماوس,فارة => souris', 'لوحة مفاتيح,كلافيي => clavier', 'سماعة,سماعات راس,كاسك => casque',
    'سماعات,ايربودز => ecouteurs', 'شاشة,اكران => ecran', 'طابعة => imprimante', 'حاسوب,بيسي,لابتوب,حاسوب محمول => pc portable',
    'شاحن => chargeur', 'كابل,كابل شحن => cable', 'هاتف,تيليفون => smartphone', 'يد تحكم,منيط => manette',
    'كاميرا => webcam', 'راوتر => routeur', 'فلاشة,فلاش ديسك => cle usb', 'قرص صلب => disque dur', 'باور بنك => powerbank',
    'laptop,ordi portable,ordinateur portable,pc portabl,portable pc => pc portable',
    'ordi,ordinateur de bureau,unite centrale,desktop => pc bureau',
    'souri,sourie,sourris,mouse => souris', 'clavie,klavier,keyboard => clavier', 'cask,headset,headphone => casque',
    'ecouteur,earbuds,airpod => ecouteurs', 'imprimente,imprimant,printer => imprimante', 'moniteur,monitor,screen => ecran',
    'manete,gamepad,controller,manette ps => manette', 'chargeure,charger => chargeur', 'cle usb,flash disk => cle usb',
    'power bank,batterie externe => powerbank', 'cartable,sac a dos pc => sac a dos'
  ];
  /* Corrections du thème qui transforment un mot d'intention en mots absents des titres : ignorées */
  var BAD_TARGETS = ['prix bas', 'premium', 'en stock', 'livraison', 'maroc', 'promotion', 'nouveaute'];

  function parseDict(text) {
    var map = {};
    String(text || '').split(/\n/).concat(EXTRA_SYN).forEach(function (line) {
      line = line.trim(); if (!line || line[0] === '#') return;
      var sep = line.indexOf('=>') > -1 ? '=>' : null; if (!sep) return;
      var parts = line.split(sep), to = norm(parts.slice(1).join(sep));
      if (!to || BAD_TARGETS.indexOf(to) > -1) return;
      parts[0].split(',').forEach(function (w) {
        w = norm(w); if (!w || w === to) return;
        if ((' ' + to + ' ').indexOf(' ' + w + ' ') > -1) return; /* expansion (ex. i7 => intel core i7) : ignorée */
        map[w] = to;
      });
    });
    return map;
  }

  /* ---------- Intentions : budget, stock, tri ---------- */
  function num(s) { return parseFloat(String(s).replace(/\s/g, '').replace(',', '.')); }
  function parseIntent(raw) {
    var q = ' ' + norm(raw) + ' ', it = { min: null, max: null, stock: false, cheap: false, chips: [] };
    var CUR = '(?:\\s*(?:dh|dhs|mad|dirhams?|درهم))?';
    var m;
    if ((m = q.match(new RegExp('\\b(?:entre|de)\\s+(\\d[\\d\\s]*)' + CUR + '\\s*(?:et|a|-)\\s*(\\d[\\d\\s]*)' + CUR, 'i')))) {
      it.min = num(m[1]); it.max = num(m[2]); q = q.replace(m[0], ' ');
    }
    if ((m = q.match(new RegExp('(?:moins de|max(?:imum)?|<|inferieur a|jusqu a|pas plus de|sous|budget|اقل من)\\s*(\\d[\\d\\s]*)' + CUR, 'i')))) {
      it.max = num(m[1]); q = q.replace(m[0], ' ');
    }
    if ((m = q.match(new RegExp('(?:plus de|min(?:imum)?|>|superieur a|a partir de|اكثر من)\\s*(\\d[\\d\\s]*)' + CUR, 'i')))) {
      it.min = num(m[1]); q = q.replace(m[0], ' ');
    }
    if (it.max == null && (m = q.match(/\b(\d{2,6})\s*(?:dh|dhs|mad|dirhams?|درهم)\b/i))) { it.max = num(m[1]); q = q.replace(m[0], ' '); }
    if (/\b(en stock|disponible|dispo|متوفر)\b/.test(q)) { it.stock = true; q = q.replace(/\b(en stock|disponibles?|dispo|متوفر)\b/g, ' '); }
    if (/\b(pas cher|moins cher|economique|bon prix|رخيص)\b/.test(q)) { it.cheap = true; q = q.replace(/\b(pas cher|moins cher|economique|bon prix|رخيص)\b/g, ' '); }
    q = q.replace(/\b(au maroc|maroc|casablanca|casa|prix|livraison|acheter|achat|meilleur|meilleure|original|neuf)\b/g, ' ');
    it.q = q.replace(/\s+/g, ' ').trim();
    if (it.min != null && it.max != null) it.chips.push({ k: 'price', t: NF.format(it.min) + ' – ' + NF.format(it.max) + ' MAD' });
    else if (it.max != null) it.chips.push({ k: 'price', t: 'Budget ≤ ' + NF.format(it.max) + ' MAD' });
    else if (it.min != null) it.chips.push({ k: 'price', t: 'Dès ' + NF.format(it.min) + ' MAD' });
    if (it.stock) it.chips.push({ k: 'stock', t: 'Disponible uniquement' });
    if (it.cheap) it.chips.push({ k: 'cheap', t: 'Prix le plus bas d\'abord' });
    return it;
  }

  /* ---------- Correction : dictionnaire puis rapprochement flou sur le vocabulaire ---------- */
  function correct(q, dict, vocab) {
    if (!q) return { q: q, changed: false, fixed: [] };
    var out = ' ' + q + ' ', changed = false, fixed = [];
    Object.keys(dict).filter(function (k) { return k.indexOf(' ') > -1; }).sort(function (a, b) { return b.length - a.length; })
      .forEach(function (k) { if (out.indexOf(' ' + k + ' ') > -1) { out = out.replace(' ' + k + ' ', ' ' + dict[k] + ' '); changed = true; } });
    var toks = out.trim().split(' ').map(function (t) {
      if (dict[t]) { changed = true; fixed.push(dict[t]); return dict[t]; }
      if (vocab && t.length === 4 && !/\d/.test(t) && !vocab.set[t] && vocab.brands) {
        for (var bi = 0; bi < vocab.brands.length; bi++) { var bw = vocab.brands[bi]; if (bw[0] === t[0] && Math.abs(bw.length - 4) <= 1 && lev(t, bw) === 1) { changed = true; fixed.push(bw); return bw; } }
      }
      if (vocab && t.length >= 5 && !/\d/.test(t) && !vocab.set[t]) {
        var best = null, bd = 3;
        for (var i = 0; i < vocab.list.length; i++) {
          var w = vocab.list[i]; if (Math.abs(w.length - t.length) > 2 || w[0] !== t[0]) continue;
          var d = lev(t, w); if (d < bd) { bd = d; best = w; }
        }
        if (best && bd <= (t.length >= 8 ? 2 : 1)) { changed = true; fixed.push(best); return best; }
      }
      return t;
    });
    var r = toks.join(' ')
      .replace(/\b(rtx|gtx|rx)(\d{3,4})\b/g, '$1 $2').replace(/\biphone(\d{2})\b/g, 'iphone $1')
      .replace(/\bmxmaster\b/g, 'mx master').replace(/\b(\d+)\s?(go|gb)\b/g, '$1go').replace(/\b(\d+)\s?(to|tb)\b/g, '$1to')
      .replace(/\b(\d{2})\s?(pouces?|inch|")/g, '$1 pouces');
    return { q: r.replace(/\s+/g, ' ').trim(), changed: changed || r !== q, fixed: fixed };
  }

  /* ---------- Classement des produits ---------- */
  function rank(products, q, brand, it) {
    var toks = q.split(' ').filter(function (t) { return t.length > 1; });
    return products.map(function (p, i) {
      var t = norm(p.title), s = 100 - i * 2;
      if (p.available) s += 40;
      var hits = toks.filter(function (k) { return t.indexOf(k) > -1; }).length;
      s += hits * 12; if (toks.length && hits === toks.length) s += 25;
      if (toks[0] && t.indexOf(toks[0]) === 0) s += 10;
      if (brand && norm(p.vendor) === norm(brand[0])) s += 20;
      if (parseFloat(p.compare_at_price_max) > parseFloat(p.price)) s += 4;
      if (it.cheap) s -= parseFloat(p.price) / 200;
      return { p: p, s: s };
    }).sort(function (a, b) { return b.s - a.s; }).map(function (x) { return x.p; });
  }

  /* ---------- Icônes ---------- */
  var IC = {
    search: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>',
    clock: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 3"/></svg>',
    trend: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m3 17 6-6 4 4 8-8"/><path d="M15 7h6v6"/></svg>',
    cart: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="20" r="1.4"/><circle cx="18" cy="20" r="1.4"/><path d="M2.5 3h2.6l2.4 11.4a1.6 1.6 0 0 0 1.6 1.3h8.7a1.6 1.6 0 0 0 1.6-1.2L21.5 7H6.2"/></svg>',
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="m5 12 5 5 9-10"/></svg>',
    arrow: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg>',
    x: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M18 6 6 18M6 6l12 12"/></svg>',
    mic: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="2.5" width="6" height="12" rx="3"/><path d="M5 11a7 7 0 0 0 14 0M12 18v3.5"/></svg>',
    wa: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2a10 10 0 0 0-8.7 15l-1.3 5 5.1-1.3A10 10 0 1 0 12 2Zm5.6 14.1c-.2.7-1.4 1.3-2 1.4-.5.1-1.2.1-1.9-.1a17 17 0 0 1-1.7-.6 13.4 13.4 0 0 1-5.1-4.5c-.4-.5-1.1-1.5-1.1-2.9s.7-2 1-2.3c.2-.3.5-.3.7-.3h.5c.2 0 .4 0 .6.5l.8 2c.1.2.1.3 0 .5l-.3.5-.4.4c-.1.2-.3.3-.1.6.2.3.8 1.3 1.6 2.1 1.1 1 2.1 1.3 2.4 1.4.3.2.5.1.6-.1l.9-1c.2-.3.4-.2.6-.1l1.9.9c.3.1.5.2.5.3.1.1.1.7-.1 1.3Z"/></svg>',
    tag: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.6 13.4 13.4 20.6a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8Z"/><circle cx="7.5" cy="7.5" r="1.5"/></svg>',
    grid: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/><rect x="3" y="14" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/></svg>'
  };
  var CAT_ICONS = [
    [/portable|laptop|macbook|notebook/, '<path d="M4 6h16v10H4z"/><path d="M2 19h20"/>'],
    [/gamer|gaming|console|ps5|playstation|manette/, '<path d="M6 11h4M8 9v4"/><circle cx="16" cy="10" r="1"/><circle cx="18" cy="13" r="1"/><path d="M7 5h10a5 5 0 0 1 5 5v2a5 5 0 0 1-9 3h-2a5 5 0 0 1-9-3v-2a5 5 0 0 1 5-5Z"/>'],
    [/ecran|moniteur/, '<rect x="3" y="4" width="18" height="12" rx="2"/><path d="M8 20h8M12 16v4"/>'],
    [/souris/, '<rect x="6" y="3" width="12" height="18" rx="6"/><path d="M12 7v4"/>'],
    [/clavier/, '<rect x="2" y="6" width="20" height="12" rx="2"/><path d="M6 10h.01M10 10h.01M14 10h.01M18 10h.01M7 14h10"/>'],
    [/casque|audio|enceinte/, '<path d="M3 14v-2a9 9 0 0 1 18 0v2"/><rect x="3" y="14" width="4" height="7" rx="1.5"/><rect x="17" y="14" width="4" height="7" rx="1.5"/>'],
    [/ecouteur/, '<path d="M8 4a4 4 0 0 0-4 4v4a2 2 0 0 0 2 2h1V4Z"/><path d="M16 4a4 4 0 0 1 4 4v4a2 2 0 0 1-2 2h-1V4Z"/><path d="M7 14v5M17 14v5"/>'],
    [/imprim|scanner/, '<path d="M6 9V3h12v6"/><rect x="3" y="9" width="18" height="8" rx="2"/><path d="M7 14h10v7H7z"/>'],
    [/smartphone|iphone|telephone/, '<rect x="7" y="2" width="10" height="20" rx="2"/><path d="M11 18h2"/>'],
    [/power|chargeur|cable|batter/, '<rect x="2" y="7" width="18" height="10" rx="2"/><path d="M22 11v2"/><path d="m10 9-2 3h4l-2 3"/>'],
    [/bureau|desktop|tout en un|all in one/, '<rect x="3" y="3" width="18" height="13" rx="2"/><path d="M9 21h6M12 16v5"/>'],
    [/reseau|routeur|wifi/, '<path d="M5 13a10 10 0 0 1 14 0M8.5 16.5a5 5 0 0 1 7 0"/><circle cx="12" cy="20" r="1"/>']
  ];
  function catIcon(title) {
    var n = norm(title);
    for (var i = 0; i < CAT_ICONS.length; i++) if (CAT_ICONS[i][0].test(n)) return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">' + CAT_ICONS[i][1] + '</svg>';
    return IC.grid;
  }

  /* ---------- Instance ---------- */
  function SmartSearch(root) {
    var self = this;
    this.root = root;
    this.form = root.querySelector('.csearch-form');
    this.input = root.querySelector('.csearch-input');
    this.panel = root.querySelector('.csearch-panel');
    this.body = root.querySelector('.cs3');
    this.clearBtn = root.querySelector('.csearch-clear');
    this.overlay = root.querySelector('.csearch-overlay');
    this.mobileClose = root.querySelector('.csearch-mobile-close');
    this.searchUrl = root.dataset.searchUrl || '/search';
    this.predictUrl = (root.dataset.predictUrl || '/search/suggest') + '.json';
    this.wa = root.dataset.whatsapp || '212624201010';
    this.trends = (root.dataset.trends || '').split('|').filter(Boolean);
    this.featuredCats = (root.dataset.featuredCats || '').split('|').filter(Boolean);
    this.featuredBrands = (root.dataset.featuredBrands || '').split('|').filter(Boolean);
    var src = root.querySelector('.csearch-corrections-source');
    // dictionnaire analysé à la demande (pas pendant le chargement de la page)
    var dictSrc = src ? src.value : '', dict = null;
    Object.defineProperty(this, 'dict', { get: function () { return dict || (dict = parseDict(dictSrc)); } });
    this.cache = {}; this.ctrl = null; this.timer = null; this.active = -1; this.seq = 0;
    this.index = null; this.vocab = null;
    this.bind();
    this.setupVoice();
    this.rotatePlaceholder();
    // préparation en tâche de fond quand le téléphone est libre : le 1er tap sur la recherche reste instantané
    var warm = function () { var idle = window.requestIdleCallback || function (f) { return setTimeout(f, 1); }; idle(function () { self.dict; self.loadIndex(); }, { timeout: 4000 }); };
    if (document.readyState === 'complete') setTimeout(warm, 1500); else window.addEventListener('load', function () { setTimeout(warm, 1500); });
  }

  SmartSearch.prototype.loadIndex = function () {
    var self = this;
    if (this.index || this._loading) return this._loading || Promise.resolve(this.index);
    var c = lsGet(INDEX_KEY, null);
    if (c && c.t && Date.now() - c.t < INDEX_TTL && c.d) { this.setIndex(c.d); return Promise.resolve(this.index); }
    this._loading = fetch(INDEX_URL, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (t) {
      var d = JSON.parse(t); lsSet(INDEX_KEY, { t: Date.now(), d: d }); self.setIndex(d); return self.index;
    }).catch(function () { self.index = { c: [], b: [] }; return self.index; });
    return this._loading;
  };
  SmartSearch.prototype.setIndex = function (d) {
    var cols = (d.c || []).map(function (x) { return { t: x[0], s: shortTitle(x[0]), u: x[1], n: x[2], k: norm(shortTitle(x[0])) }; });
    var brands = (d.b || []).map(function (x) { return { t: x[0], u: x[1], l: x[2], k: norm(x[0]) }; });
    this.index = { c: cols, b: brands };
    var set = {};
    cols.forEach(function (c) { c.k.split(' ').forEach(function (w) { if (w.length >= 4 && !/\d/.test(w)) set[w] = 1; }); });
    brands.forEach(function (b) { b.k.split(' ').forEach(function (w) { if (w.length >= 3) set[w] = 1; }); });
    Object.keys(this.dict).forEach(function (k) { var v = this.dict[k]; v.split(' ').forEach(function (w) { if (w.length >= 4) set[w] = 1; }); }, this);
    this.vocab = { set: set, list: Object.keys(set), brands: brands.map(function (b) { return b.k; }).filter(function (k) { return k.length >= 3 && k.length <= 6 && k.indexOf(' ') < 0; }) };
  };

  SmartSearch.prototype.bind = function () {
    var self = this, input = this.input;
    // le panneau s'affiche d'abord ; son contenu est construit juste après l'affichage (tap plus réactif)
    var afterPaint = function (f) { requestAnimationFrame(function () { setTimeout(f, 0); }); };
    input.addEventListener('focus', function () { self.open(); afterPaint(function () { self.loadIndex().then(function () { if (!input.value.trim()) self.renderHome(); }); }); });
    input.addEventListener('input', function () {
      var v = input.value.trim();
      if (self.clearBtn) self.clearBtn.hidden = !v;
      self.open(); clearTimeout(self.timer);
      if (v.length < 2) { self.renderHome(); return; }
      self.timer = setTimeout(function () { self.search(v); }, 140);
    });
    input.addEventListener('keydown', function (e) { self.onKey(e); });
    if (this.clearBtn) this.clearBtn.addEventListener('click', function () { input.value = ''; self.clearBtn.hidden = true; self.renderHome(); input.focus(); });
    if (this.overlay) this.overlay.addEventListener('click', function () { self.close(); });
    if (this.mobileClose) this.mobileClose.addEventListener('click', function () { self.close(); });
    var back = this.root.querySelector('.cs3-back');
    if (back) back.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); self.close(); input.blur(); });
    document.addEventListener('click', function (e) { if (!self.root.contains(e.target)) self.close(); });
    document.addEventListener('keydown', function (e) {
      var tag = (e.target && e.target.tagName) || '';
      if ((e.key === '/' && !/INPUT|TEXTAREA|SELECT/.test(tag)) || ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'k')) {
        if (self.root.offsetParent === null) return;
        e.preventDefault(); input.focus();
      }
    });
    this.form.addEventListener('submit', function (e) {
      var raw = input.value.trim(); if (!raw) { e.preventDefault(); return; }
      e.preventDefault(); self.addHistory(raw); window.location.href = self.viewAllUrl(raw);
    });
    this.body.addEventListener('click', function (e) { self.onClick(e); });
  };

  SmartSearch.prototype.open = function () { this.root.classList.add('open'); this.input.setAttribute('aria-expanded', 'true'); document.documentElement.classList.add('cs3-open'); };
  SmartSearch.prototype.close = function () { this.root.classList.remove('open'); this.input.setAttribute('aria-expanded', 'false'); this.active = -1; document.documentElement.classList.remove('cs3-open'); };

  /* ---------- Placeholder animé ---------- */
  SmartSearch.prototype.rotatePlaceholder = function () {
    var input = this.input, base = input.getAttribute('placeholder') || 'Rechercher…';
    var ex = ['« souris Logitech sans fil »', '« PC portable i7 16 Go »', '« écran 27 pouces »', '« casque gamer moins de 500 dh »', '« imprimante Epson EcoTank »', '« clavier mécanique »'];
    var i = 0;
    setInterval(function () {
      if (document.activeElement === input || input.value) return;
      input.setAttribute('placeholder', i % 2 ? 'Essayez ' + ex[(i >> 1) % ex.length] : base);
      i++;
    }, 3200);
  };

  /* ---------- Recherche vocale ---------- */
  SmartSearch.prototype.setupVoice = function () {
    var SR = window.SpeechRecognition || window.webkitSpeechRecognition, self = this;
    var btn = this.root.querySelector('.cs3-mic'); if (!btn) return;
    if (!SR) { btn.hidden = true; return; }
    btn.hidden = false;
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var rec = new SR(); rec.lang = 'fr-FR'; rec.interimResults = true; rec.maxAlternatives = 1;
      btn.classList.add('is-listening');
      rec.onresult = function (ev) {
        var txt = Array.prototype.map.call(ev.results, function (r) { return r[0].transcript; }).join(' ');
        self.input.value = txt; self.input.dispatchEvent(new Event('input', { bubbles: true }));
      };
      rec.onend = function () { btn.classList.remove('is-listening'); self.input.focus(); };
      rec.onerror = function () { btn.classList.remove('is-listening'); };
      try { rec.start(); track('voice_search', {}); } catch (err) { btn.classList.remove('is-listening'); }
    });
  };

  /* ---------- Historique ---------- */
  SmartSearch.prototype.history = function () { return lsGet(HIST_KEY, []); };
  SmartSearch.prototype.addHistory = function (t) {
    t = String(t || '').trim(); if (t.length < 2) return;
    var h = this.history().filter(function (x) { return norm(x) !== norm(t); }); h.unshift(t); lsSet(HIST_KEY, h.slice(0, 6));
  };

  /* ---------- URL « voir tout » avec filtres ---------- */
  SmartSearch.prototype.viewAllUrl = function (raw) {
    var it = parseIntent(raw), c = correct(it.q, this.dict, this.vocab), q = c.q || it.q || raw;
    var u = this.searchUrl + '?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last';
    if (it.max != null) u += '&filter.v.price.lte=' + it.max;
    if (it.min != null) u += '&filter.v.price.gte=' + it.min;
    if (it.stock) u += '&filter.v.availability=1';
    if (it.cheap) u += '&sort_by=price-ascending';
    return u;
  };

  /* ---------- Requête Predictive Search ---------- */
  SmartSearch.prototype.fetchSuggest = function (q, limit) {
    var key = q + '|' + (limit || 10);
    if (this.cache[key]) return Promise.resolve(this.cache[key]);
    var self = this, p = new URLSearchParams();
    p.set('q', q); p.set('resources[type]', 'product,query,collection');
    p.set('resources[limit]', String(limit || 10)); p.set('resources[limit_scope]', 'each');
    p.set('resources[options][unavailable_products]', 'last'); p.set('resources[options][fields]', FIELDS);
    if (this.ctrl) this.ctrl.abort();
    this.ctrl = new AbortController();
    return fetch(this.predictUrl + '?' + p.toString(), { signal: this.ctrl.signal, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) { var R = (j.resources && j.resources.results) || {}; var o = { p: R.products || [], q: R.queries || [], c: R.collections || [] }; self.cache[key] = o; return o; });
  };

  /* ---------- Recherche principale ---------- */
  SmartSearch.prototype.search = function (raw) {
    var self = this, seq = ++this.seq;
    this.loadIndex().then(function () {
      var it = parseIntent(raw);
      var c = correct(it.q, self.dict, self.vocab);
      var q = c.q;
      var brand = self.detectBrand(q);
      if (brand && (' ' + it.q + ' ').indexOf(' ' + brand.k + ' ') < 0 && !(c.fixed || []).some(function (f) { return (' ' + f + ' ').indexOf(' ' + brand.k + ' ') > -1 && f.split(' ').length <= 2; })) brand = null;
      var cats = self.matchCats(q, brand);
      if (!q && (it.max != null || it.min != null)) q = brand ? brand.t : '';
      if (!q) { self.renderHome(); return; }
      self.renderLoading(raw);
      self.fetchSuggest(q, 10).then(function (res) {
        if (seq !== self.seq) return;
        var products = self.applyIntent(res.p, it);
        if (products.length || res.p.length) return self.render(raw, it, c, q, brand, cats, res, products, null);
        /* Aucun résultat : on relâche la requête mot par mot */
        var toks = q.split(' ').filter(function (t) { return t.length > 1; });
        var tries = [];
        if (c.changed && it.q && it.q !== q) tries.push(it.q);
        if (toks.length > 1) tries.push(toks.slice(0, -1).join(' '), toks.filter(function (t) { return t.length > 2; }).join(' OR '));
        if (toks.length) tries.push(toks[0]);
        var next = function (i) {
          if (i >= tries.length) return self.render(raw, it, c, q, brand, cats, res, [], { none: true });
          return self.fetchSuggest(tries[i], 8).then(function (r2) {
            if (seq !== self.seq) return;
            var p2 = self.applyIntent(r2.p, it);
            if (p2.length) return self.render(raw, it, c, q, brand, cats, r2, p2, { relaxed: tries[i].replace(/ OR /g, ' ou ') });
            return next(i + 1);
          });
        };
        return next(0);
      }).catch(function (e) { if (e && e.name === 'AbortError') return; });
    });
  };

  SmartSearch.prototype.applyIntent = function (products, it) {
    var list = products.filter(function (p) {
      var pr = parseFloat(p.price);
      if (it.max != null && pr > it.max) return false;
      if (it.min != null && pr < it.min) return false;
      if (it.stock && !p.available) return false;
      return true;
    });
    return list;
  };

  SmartSearch.prototype.detectBrand = function (q) {
    if (!this.index || !q) return null;
    var nq = ' ' + q + ' ', best = null;
    this.index.b.forEach(function (b) { if (b.k.length >= 2 && nq.indexOf(' ' + b.k + ' ') > -1 && (!best || b.k.length > best.k.length)) best = b; });
    return best;
  };

  var WEAK = { sans: 1, fil: 1, avec: 1, pour: 1, les: 1, des: 1, une: 1, pas: 1, noir: 1, blanc: 1, gris: 1, pro: 1, plus: 1 };
  SmartSearch.prototype.matchCats = function (q, brand) {
    if (!this.index || !q) return [];
    var toks = q.split(' ').filter(function (t) { return t.length >= 3 || /\d/.test(t); });
    if (!toks.length) return [];
    var strong = toks.filter(function (t) { return !WEAK[t]; });
    var otherBrands = brand ? this.index.b.filter(function (b) { return b.k !== brand.k && b.k.length >= 2 && b.k.indexOf(' ') < 0; }).map(function (b) { return b.k; }) : [];
    var scored = [];
    this.index.c.forEach(function (c) {
      var hay = ' ' + c.k + ' ', hits = 0, strongHits = 0;
      toks.forEach(function (t) { if (hay.indexOf(' ' + t) > -1) { hits++; if (!WEAK[t]) strongHits++; } });
      if (!strongHits) return;
      var s = strongHits * 100 + (hits - strongHits) * 25 + Math.min(c.n, 300) / 3 - c.k.length / 4;
      if (strong.length && strongHits === strong.length) s += 150;
      if (brand) {
        if (hay.indexOf(' ' + brand.k + ' ') > -1) s += 160;
        else if (otherBrands.some(function (k) { return hay.indexOf(' ' + k + ' ') > -1; })) s -= 140;
      }
      scored.push({ c: c, s: s });
    });
    scored.sort(function (a, b) { return b.s - a.s; });
    var seen = {}, out = [];
    scored.forEach(function (x) { var k = x.c.k; if (!seen[k] && out.length < 6) { seen[k] = 1; out.push(x.c); } });
    return out;
  };

  /* ---------- Rendu ---------- */
  function fold(str) {
    return String(str).split('').map(function (ch) { var f = ch.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase(); return f.length === 1 ? f : ch.toLowerCase().charAt(0) || ch; }).join('');
  }
  SmartSearch.prototype.hl = function (text, q) {
    var src = String(text), toks = q.split(' ').filter(function (x) { return x.length > 1 && x !== 'or'; });
    if (!toks.length) return esc(src);
    var ft = fold(src), marks = [];
    toks.forEach(function (k) { var i = ft.indexOf(k); while (i > -1) { marks.push([i, i + k.length]); i = ft.indexOf(k, i + k.length); } });
    if (!marks.length) return esc(src);
    marks.sort(function (a, b) { return a[0] - b[0] || b[1] - a[1]; });
    var res = '', pos = 0;
    marks.forEach(function (m) { if (m[0] < pos) return; res += esc(src.slice(pos, m[0])) + '<mark>' + esc(src.slice(m[0], m[1])) + '</mark>'; pos = m[1]; });
    return res + esc(src.slice(pos));
  };

  SmartSearch.prototype.productRow = function (p, q, idx) {
    var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
    if (img) { if (img.indexOf('//') === 0) img = 'https:' + img; img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=160'; }
    var cmp = parseFloat(p.compare_at_price_max), pr = parseFloat(p.price);
    var off = cmp > pr ? Math.round((cmp - pr) / cmp * 100) : 0;
    var url = String(p.url || '').split('?')[0];
    return '<div class="cs3-p" data-nav data-href="' + esc(url) + '">' +
      '<a class="cs3-p__link" href="' + esc(url) + '" tabindex="-1">' +
      '<span class="cs3-p__img">' + (img ? '<img src="' + esc(img) + '" alt="" ' + (idx < 5 ? 'loading="eager" fetchpriority="high"' : 'loading="lazy"') + ' width="64" height="64">' : '') +
      (off >= 5 ? '<span class="cs3-p__off">-' + off + '%</span>' : '') + '</span>' +
      '<span class="cs3-p__body">' + (p.vendor ? '<span class="cs3-p__brand">' + esc(p.vendor) + '</span>' : '') +
      '<span class="cs3-p__title">' + this.hl(p.title, q) + '</span>' +
      '<span class="cs3-p__stock ' + (p.available ? 'is-in' : 'is-out') + '">' + (p.available ? 'Disponible' : 'Épuisé') + '</span></span>' +
      '<span class="cs3-p__price"><b>' + (p.price_min !== p.price_max ? 'dès ' : '') + money(p.price) + '</b>' + (off >= 5 ? '<s>' + money(cmp) + '</s>' : '') + '</span>' +
      '</a>' +
      (p.available ? '<button type="button" class="cs3-add" data-handle="' + esc(p.handle) + '" aria-label="Ajouter au panier">' + IC.cart + '</button>' : '') +
      '</div>';
  };

  SmartSearch.prototype.renderLoading = function () {
    if (this.body.querySelector('.cs3-res')) { this.body.classList.add('is-loading'); return; }
    var sk = '';
    for (var i = 0; i < 5; i++) sk += '<div class="cs3-sk"><i></i><span><b></b><b></b></span></div>';
    this.body.innerHTML = '<div class="cs3-loading">' + sk + '</div>';
  };

  SmartSearch.prototype.render = function (raw, it, c, q, brand, cats, res, products, state) {
    this.body.classList.remove('is-loading');
    this.active = -1;
    var self = this, html = '', ranked = rank(products, q, brand, it).slice(0, 8);
    var viewAll = this.viewAllUrl(raw);

    /* bandeau d'intentions */
    var chips = it.chips.slice();
    if (brand) chips.unshift({ k: 'brand', t: 'Marque : ' + brand.t });
    if (c.changed && q && norm(it.q) !== q) chips.push({ k: 'fix', t: 'Recherche corrigée : « ' + q + ' »' });
    if (chips.length) {
      html += '<div class="cs3-intent">' + chips.map(function (x) { return '<span class="cs3-chip cs3-chip--' + x.k + '">' + (x.k === 'fix' ? IC.check : IC.tag) + esc(x.t) + '</span>'; }).join('') + '</div>';
    }

    /* colonne latérale */
    var side = '';
    var qs = (res.q || []).filter(function (x) { return norm(x.text) !== norm(raw); }).slice(0, 4);
    if (qs.length) {
      side += '<div class="cs3-block"><div class="cs3-h">Suggestions</div>' + qs.map(function (x) {
        return '<a class="cs3-s" data-nav href="' + esc(self.viewAllUrl(x.text)) + '" data-term="' + esc(x.text) + '">' + IC.search + '<span>' + (x.styled_text || esc(x.text)) + '</span></a>';
      }).join('') + '</div>';
    }
    if (brand) {
      side += '<div class="cs3-block"><div class="cs3-h">Marque</div><a class="cs3-brand" data-nav href="' + esc(brand.u) + '">' +
        (brand.l ? '<img src="' + esc(brand.l) + '" alt="" loading="lazy">' : '<span class="cs3-mono">' + esc(brand.t.slice(0, 2).toUpperCase()) + '</span>') +
        '<span>Tout ' + esc(brand.t) + '</span>' + IC.arrow + '</a></div>';
    }
    if (cats.length) {
      side += '<div class="cs3-block"><div class="cs3-h">Catégories</div>' + cats.slice(0, 5).map(function (x) {
        return '<a class="cs3-cat" data-nav href="' + esc(x.u) + (it.max != null ? '?filter.v.price.lte=' + it.max : '') + '">' + catIcon(x.s) + '<span>' + esc(x.s) + '</span><em>' + x.n + '</em></a>';
      }).join('') + '</div>';
    }

    /* produits */
    var main = '';
    if (state && state.none) {
      main += '<div class="cs3-empty"><div class="cs3-empty__t">Aucun produit pour « ' + esc(raw) + ' »</div>' +
        '<p>Vérifiez l\'orthographe, essayez un mot plus général ou une marque.</p>' +
        (it.max != null ? '<p>Aucun article ne correspond à ce budget : <a href="' + esc(this.viewAllUrl(it.q)) + '">voir sans limite de prix</a>.</p>' : '') +
        '<a class="cs3-wa" target="_blank" rel="noopener" href="https://wa.me/' + esc(this.wa) + '?text=' + encodeURIComponent('Bonjour Connecto, je cherche : ' + raw) + '">' + IC.wa +
        '<span><b>On vous le trouve !</b>Demandez ce produit sur WhatsApp</span></a></div>';
    } else {
 var toks3 = q.split(' ').filter(function (t) { return t.length >= 3 && !/^\d+$/.test(t) && t !== 'or'; });
      var weak = !(state && state.none) && toks3.length && ranked.length && !ranked.some(function (p) { var nt = norm(p.title + ' ' + p.vendor); return toks3.some(function (t) { return nt.indexOf(t) > -1; }); });
      if (weak) {
        main += '<div class="cs3-weak"><div><b>Nous n\'avons pas « ' + esc(raw) + ' » en ce moment.</b><span>Voici des produits proches — ou demandez-le nous, on vous le trouve.</span></div>' +
          '<a class="cs3-wa cs3-wa--sm" target="_blank" rel="noopener" href="https://wa.me/' + esc(this.wa) + '?text=' + encodeURIComponent('Bonjour Connecto, je cherche : ' + raw) + '">' + IC.wa + '<span>WhatsApp</span></a></div>';
        track('search_no_results', { search_term: raw, weak: true });
      }
      if (state && state.relaxed) main += '<div class="cs3-note">Pas de correspondance exacte — résultats proches pour « ' + esc(state.relaxed) + ' »</div>';
      if (!ranked.length && res.p.length && (it.max != null || it.min != null || it.stock)) {
        main += '<div class="cs3-note">Aucun produit dans ce budget parmi les meilleurs résultats. <a href="' + esc(viewAll) + '">Voir la recherche complète</a></div>';
        ranked = rank(res.p, q, brand, it).slice(0, 4);
      }
      main += '<div class="cs3-h cs3-h--main">Produits</div><div class="cs3-plist">' + ranked.map(function (p, i) { return self.productRow(p, q, i); }).join('') + '</div>';
      main += '<a class="cs3-all" data-nav href="' + esc(viewAll) + '">Voir tous les résultats pour « ' + esc(raw) + ' »' + IC.arrow + '</a>';
    }

    html += '<div class="cs3-res' + (side ? '' : ' cs3-res--single') + '">' + (side ? '<aside class="cs3-side">' + side + '</aside>' : '') + '<div class="cs3-main">' + main + '</div></div>';
    this.body.innerHTML = html;
    this.body.scrollTop = 0;
    this.panel.scrollTop = 0;
    if (state && state.none) track('search_no_results', { search_term: raw }); else track('search', { search_term: raw });
  };

  SmartSearch.prototype.renderHome = function () {
    var self = this, html = '';
    this.body.classList.remove('is-loading');
    var h = this.history();
    if (h.length) {
      html += '<div class="cs3-block"><div class="cs3-h">Recherches récentes<button type="button" class="cs3-clearh">Effacer</button></div><div class="cs3-chips">' +
        h.map(function (t) { return '<a class="cs3-pill" data-nav data-term="' + esc(t) + '" href="' + esc(self.viewAllUrl(t)) + '">' + IC.clock + esc(t) + '<button type="button" class="cs3-delh" data-term="' + esc(t) + '" aria-label="Retirer">' + IC.x + '</button></a>'; }).join('') + '</div></div>';
    }
    if (this.trends.length) {
      html += '<div class="cs3-block"><div class="cs3-h">Tendances</div><div class="cs3-chips">' +
        this.trends.map(function (t) { return '<a class="cs3-pill cs3-pill--trend" data-nav data-term="' + esc(t) + '" href="' + esc(self.viewAllUrl(t)) + '">' + IC.trend + esc(t) + '</a>'; }).join('') + '</div></div>';
    }
    if (this.index && this.index.c.length) {
      var byUrl = {}; this.index.c.forEach(function (c) { byUrl[c.u.split('?')[0].replace(/\/$/, '')] = c; });
      var cats = this.featuredCats.map(function (hd) { return byUrl['/collections/' + hd]; }).filter(Boolean).slice(0, 8);
      if (cats.length) {
        html += '<div class="cs3-block"><div class="cs3-h">Catégories populaires</div><div class="cs3-tiles">' + cats.map(function (c) {
          return '<a class="cs3-tile" data-nav href="' + esc(c.u) + '">' + catIcon(c.s) + '<span>' + esc(c.s.replace(/\s*(au\s)?maroc.*$/i, '')) + '</span><em>' + c.n + ' produits</em></a>';
        }).join('') + '</div></div>';
      }
      var bmap = {}; this.index.b.forEach(function (b) { bmap[b.k] = b; });
      var brands = this.featuredBrands.map(function (n) { return bmap[norm(n)]; }).filter(Boolean).slice(0, 10);
      if (brands.length) {
        html += '<div class="cs3-block"><div class="cs3-h">Marques</div><div class="cs3-brands">' + brands.map(function (b) {
          return '<a class="cs3-bl" data-nav href="' + esc(b.u) + '" title="' + esc(b.t) + '">' + (b.l ? '<img src="' + esc(b.l) + '" alt="' + esc(b.t) + '" loading="lazy">' : '<span>' + esc(b.t) + '</span>') + '</a>';
        }).join('') + '</div></div>';
      }
    }
    html += '<div class="cs3-tip"><kbd>/</kbd> pour rechercher depuis n\'importe où · essayez « souris logitech moins de 300 dh »</div>';
    this.body.innerHTML = '<div class="cs3-home">' + html + '</div>';
    this.active = -1;
  };

  /* ---------- Clics ---------- */
  SmartSearch.prototype.onClick = function (e) {
    var self = this, t = e.target;
    var del = t.closest('.cs3-delh');
    if (del) { e.preventDefault(); e.stopPropagation(); lsSet(HIST_KEY, this.history().filter(function (x) { return x !== del.dataset.term; })); this.renderHome(); return; }
    if (t.closest('.cs3-clearh')) { e.preventDefault(); lsSet(HIST_KEY, []); this.renderHome(); return; }
    var add = t.closest('.cs3-add');
    if (add) { e.preventDefault(); e.stopPropagation(); this.quickAdd(add); return; }
    var term = t.closest('[data-term]');
    if (term) this.addHistory(term.dataset.term);
    else if (t.closest('.cs3-p,.cs3-all,.cs3-cat,.cs3-brand')) this.addHistory(this.input.value);
    var row = t.closest('.cs3-p');
    if (row && !t.closest('a')) { window.location.href = row.dataset.href; }
  };

  /* ---------- Ajout rapide au panier ---------- */
  SmartSearch.prototype.quickAdd = function (btn) {
    if (btn.classList.contains('is-busy')) return;
    btn.classList.add('is-busy');
    var handle = btn.dataset.handle;
    fetch('/products/' + encodeURIComponent(handle) + '.js').then(function (r) { return r.json(); }).then(function (prod) {
      var v = (prod.variants || []).filter(function (x) { return x.available; })[0];
      if (!v) throw new Error('indisponible');
      var notif = document.querySelector('cart-notification');
      var body = { items: [{ id: v.id, quantity: 1 }] };
      if (notif && typeof notif.getSectionsToRender === 'function') {
        body.sections = notif.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
      }
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status && res.status >= 400) throw new Error(res.description || 'erreur');
          btn.classList.remove('is-busy'); btn.classList.add('is-done'); btn.innerHTML = IC.check;
          track('add_to_cart', { currency: 'MAD', value: v.price / 100, items: [{ item_id: String(v.id), item_name: prod.title }] });
          try {
            var item = res.items ? res.items[0] : res;
            if (notif && res.sections && typeof notif.renderContents === 'function') {
              notif.renderContents(Object.assign({}, item, { sections: res.sections }));
            }
          } catch (e) {}
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            document.querySelectorAll('.wbhcartitem, .cart-count-bubble span[aria-hidden], [data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
            document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));
          });
          setTimeout(function () { btn.classList.remove('is-done'); btn.innerHTML = IC.cart; }, 2400);
        });
    }).catch(function () {
      btn.classList.remove('is-busy'); btn.classList.add('is-err');
      setTimeout(function () { btn.classList.remove('is-err'); }, 1800);
    });
  };

  /* ---------- Clavier ---------- */
  SmartSearch.prototype.onKey = function (e) {
    var items = Array.prototype.slice.call(this.body.querySelectorAll('[data-nav]'));
    if (e.key === 'Escape') { this.close(); this.input.blur(); return; }
    if (!items.length) return;
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      e.preventDefault();
      this.active = e.key === 'ArrowDown' ? Math.min(this.active + 1, items.length - 1) : Math.max(this.active - 1, 0);
      items.forEach(function (el, i) { el.classList.toggle('is-active', i === this.active); if (i === this.active) el.scrollIntoView({ block: 'nearest' }); }, this);
    } else if (e.key === 'Enter' && this.active > -1) {
      e.preventDefault();
      var el = items[this.active];
      this.addHistory(el.dataset.term || this.input.value);
      window.location.href = el.dataset.href || el.getAttribute('href');
    }
  };

  /* ---------- Init ---------- */
  function init() {
    document.querySelectorAll('.csearch[data-cs3]').forEach(function (root) {
      if (root.__cs3) return; root.__cs3 = new SmartSearch(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
